/* ============================================================
   The Rare Steps — PDP behaviours
   - "Complete the look" multi-add (AJAX → cart drawer, with a
     native <form> POST fallback so it always works)
   - Optional order-by countdown on the delivery estimate
   ============================================================ */
(function () {
  if (window.__trsProductInit) return;
  window.__trsProductInit = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const moneyFormat = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || '';

  function formatMoney(cents, symbol) {
    const amount = (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return (symbol || '₹') + amount;
  }

  /* ---------- Complete the look -------------------------------------------- */
  function initBundle(bundle) {
    const cards = Array.from(bundle.querySelectorAll('[data-ctl-card]'));
    const addBtn = bundle.querySelector('[data-ctl-add]');
    const totalEl = bundle.querySelector('[data-ctl-total]');
    const countEl = bundle.querySelector('[data-ctl-count]');
    const symbol = bundle.getAttribute('data-currency-symbol') || '₹';
    if (!cards.length || !addBtn) return;

    function selectedCards() {
      return cards.filter((c) => {
        const cb = c.querySelector('[data-ctl-toggle]');
        return cb && cb.checked;
      });
    }

    function syncCard(card) {
      const cb = card.querySelector('[data-ctl-toggle]');
      const select = card.querySelector('[data-ctl-variant]');
      const qty = card.querySelector('[data-ctl-qty]');
      const on = cb && cb.checked;
      card.classList.toggle('is-selected', !!on);
      // Disable both fields when deselected so the no-JS native POST never
      // submits an orphaned line item.
      if (select) select.disabled = !on;
      if (qty) qty.disabled = !on;
    }

    function recalc() {
      const sel = selectedCards();
      let total = 0;
      sel.forEach((card) => {
        const select = card.querySelector('[data-ctl-variant]');
        let price = parseInt(card.getAttribute('data-price') || '0', 10);
        if (select && select.selectedOptions[0]) {
          const vp = select.selectedOptions[0].getAttribute('data-price');
          if (vp) price = parseInt(vp, 10);
        }
        total += price;
      });
      if (totalEl) totalEl.textContent = formatMoney(total, symbol);
      if (countEl) countEl.textContent = sel.length + (sel.length === 1 ? ' item' : ' items');
      addBtn.disabled = sel.length === 0;
    }

    cards.forEach((card) => {
      const cb = card.querySelector('[data-ctl-toggle]');
      const select = card.querySelector('[data-ctl-variant]');
      if (cb) cb.addEventListener('change', () => { syncCard(card); recalc(); });
      if (select) select.addEventListener('change', recalc);
      syncCard(card);
    });
    recalc();

    bundle.addEventListener('submit', async function (e) {
      e.preventDefault();
      const sel = selectedCards();
      if (!sel.length) return;

      const items = sel
        .map((card) => {
          const select = card.querySelector('[data-ctl-variant]');
          const id = select ? select.value : card.getAttribute('data-default-variant');
          return id ? { id: Number(id), quantity: 1 } : null;
        })
        .filter(Boolean);
      if (!items.length) return;

      const original = addBtn.textContent;
      addBtn.setAttribute('aria-busy', 'true');
      addBtn.textContent = 'Adding…';

      const drawer = document.querySelector('cart-drawer');
      const body = { items: items };
      let sectionList = [];
      if (drawer && typeof drawer.getSectionsToRender === 'function') {
        try {
          sectionList = drawer.getSectionsToRender().map((s) => s.id);
          body.sections = sectionList;
          body.sections_url = window.location.pathname;
        } catch (err) {
          sectionList = [];
        }
      }

      try {
        const res = await fetch(root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        });
        const data = await res.json();
        if (!res.ok) throw new Error((data && data.description) || 'Add to cart failed');

        addBtn.textContent = 'Added ✓';

        if (drawer && data.sections && typeof drawer.renderContents === 'function') {
          drawer.renderContents(data);
          if (typeof drawer.open === 'function') drawer.open();
        } else {
          // No drawer available → go to the cart so the shopper sees the result.
          window.location = root + 'cart';
          return;
        }

        setTimeout(() => {
          addBtn.textContent = original;
          addBtn.removeAttribute('aria-busy');
        }, 1600);
      } catch (err) {
        // Hard fallback: submit natively to /cart/add (full page).
        addBtn.removeAttribute('aria-busy');
        addBtn.textContent = original;
        bundle.setAttribute('data-allow-native', 'true');
        bundle.submit();
      }
    });
  }

  /* ---------- Delivery order-by countdown ---------------------------------- */
  function initCutoffs() {
    const nodes = document.querySelectorAll('[data-trs-cutoff-hour]');
    nodes.forEach((node) => {
      const hour = parseInt(node.getAttribute('data-trs-cutoff-hour'), 10);
      if (isNaN(hour)) return;
      const valueEl = node.querySelector('[data-trs-cutoff-value]');
      const tick = () => {
        const now = new Date();
        const cutoff = new Date();
        cutoff.setHours(hour, 0, 0, 0);
        const diff = cutoff - now;
        if (diff <= 0) {
          node.hidden = true;
          return;
        }
        const h = Math.floor(diff / 3600000);
        const m = Math.floor((diff % 3600000) / 60000);
        if (valueEl) valueEl.textContent = h + 'h ' + m + 'm';
      };
      tick();
      setInterval(tick, 60000);
    });
  }

  /* ---------- Closing CTA → scroll to the buy box -------------------------- */
  function initScrollTop() {
    document.addEventListener('click', function (e) {
      const trigger = e.target.closest('[data-trs-scrolltop]');
      if (!trigger) return;
      const target = document.querySelector('product-info, .product__info-wrapper, #MainContent');
      if (!target) return; // let the link navigate normally
      e.preventDefault();
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  }

  function init() {
    document.querySelectorAll('[data-ctl]').forEach(initBundle);
    initCutoffs();
    initScrollTop();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
